import React from "react";
import { ReactComponent as Logodefault } from './webdev-default.svg';
import { ReactComponent as Logoblue } from './webdev-blue.svg';
import { ReactComponent as Logogreen } from './webdev-green.svg';
import Container from 'react-bootstrap/Container';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./Title.css"

function Title(props){
    return(
        <div className="context">
            
            <Container fluid='md'>
                
                <Row>
                <Col>
                <div className="title">
                    <h1>Hello... I'm <span className="Name">Ishan</span></h1>
                    <div className='cube'> 
                    <div className="cube-in">
                        <div className='flip'>
                            <p>Data Engineer</p>
                        </div>
                        <div className='flop'>
                            <p>Full Stack Developer</p>
                        </div>
                        </div>
                    </div>
                    
                </div>               
                </Col>
                <Col>
                <div className="home-img floating">
                    {(props.imgcolor)==="default"&&<Logodefault className="homeimg"></Logodefault>}
                    {(props.imgcolor)==="blue"&&<Logoblue className="homeimg"></Logoblue>}
                    {(props.imgcolor)==="green"&&<Logogreen className="homeimg"></Logogreen>}               
                </div>
                </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Title;